import { logo } from './logo'
import { dashboard } from './dashboard'
import { auctionManagment } from './auction-managment'
import { carManager } from './car-manager'
import { managers } from './managers'
import { pages } from './pages'
import { sales } from './sales'
import { support } from './support'
import { user } from './user'
import { add } from './add'
import { dots } from './dots'
import { incomingInventory } from './incoming-inventory'
import { marketplaceListing } from './marketplace-listing'
import { listingOver } from './listing-over'
import { sold } from './sold'
import { reconciliation } from './reconciliation'
import { download } from './download'

import {
  cilBell,
  cilEnvelopeOpen,
  cilTask,
  cilUser,
  cilLockLocked
} from '@coreui/icons'

export const iconsSet = Object.assign(
  {},
  {
    logo,
    dashboard,
    auctionManagment,
    carManager,
    managers,
    pages,
    sales,
    support,
    user,
    add,
    dots,
    incomingInventory,
    marketplaceListing,
    listingOver,
    sold,
    reconciliation,
    download
  },
  {
    cilTask,
    cilBell,
    cilEnvelopeOpen,
    cilUser,
    cilLockLocked
  }
)
